import { Component, OnInit, Input } from '@angular/core';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-gantt',
  templateUrl: './gantt.component.html',
  styleUrls: ['./gantt.component.scss'],
})
export class GanttComponent implements OnInit {

  @Input() project: any;
  gantt_start: dayjs.Dayjs;
  gantt_end: dayjs.Dayjs;
  gantt_months = [];
  gantt_days = [];

  constructor() { }

  ngOnInit() {
    this.FormatProject();
    this.FormatTask();
  }

  async FormatProject() {

    this.gantt_start = dayjs(this.project.internal_start_date).startOf('day').add(-1, 'day');
    this.gantt_end = dayjs(this.project.internal_end_date).startOf('day').add(1, 'day');


    let currentDateDays = this.gantt_start.clone();
    let currentDateMonths = this.gantt_start.clone();

    while (currentDateDays.isBefore(this.gantt_end) || currentDateDays.isSame(this.gantt_end, 'day')) {
      this.gantt_days.push(currentDateDays); // Add the current date to the array
      currentDateDays = currentDateDays.add(1, 'day'); // Move to the next day
    }

    while (currentDateMonths.isBefore(this.gantt_end) || currentDateMonths.isSame(this.gantt_end, 'day')) {
      this.gantt_days.push(currentDateMonths); // Add the current date to the array
      currentDateMonths = currentDateMonths.add(1, 'month'); // Move to the next day
    }

  }

  async FormatTask() {
    this.project.tasks.forEach(task => {
      task.gantt_start = dayjs(task.due_date).startOf('day');
      task.gantt_end = dayjs(task.due_date).startOf('day');
    });
  }

}
